import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { SummaryElementType } from "abreact/expression/ui/editor/readonly/ExpressionSummaryElement";
import { ValueFormatAttributesUtils } from "abweb/dto/ds/ValueFormatAttributesUtils";
import * as React from "react";
export class DefaultOperandValueValueRenderer {
  constructor(expressionDomainModel) {
    _defineProperty(this, "expressionDomainModel", void 0);
    this.expressionDomainModel = expressionDomainModel;
  }
  richValue(element) {
    let value = null;
    switch (element.type) {
      case SummaryElementType.CLOSE_PAREN:
      case SummaryElementType.OPEN_PAREN:
      case SummaryElementType.LIST_BULLET:
      case SummaryElementType.LIST_BULLET_ELSE:
      case SummaryElementType.TEXT:
      case SummaryElementType.AND:
      case SummaryElementType.OR:
        value = element.value;
        break;
      case SummaryElementType.LEAF:
        let leafNode = element.value;
        value = this.getRichDisplayValueForNode(leafNode, element.expSummaryElementOptions);
        break;
      case SummaryElementType.OPERATOR:
        let operatorNode = element.value;
        if (operatorNode.operatorID != null) {
          let expOperator = this.expressionDomainModel.getExpOperator(operatorNode.operatorID);
          if (expOperator) {
            value = this.getRichDisplayValueForOperatorNode(expOperator);
          }
          value = value || "UNKNOWN";
        }
        break;
      default:
        throw new Error(`Unsupported SummaryElementType: ${element.type}`);
    }
    if (element.expSummaryElementOptions?.cssClassName && value != null) {
      value = /*#__PURE__*/React.createElement("span", {
        className: element.expSummaryElementOptions?.cssClassName
      }, value);
    }
    return value;
  }
  stringValue(element) {
    let value = "";
    switch (element.type) {
      case SummaryElementType.CLOSE_PAREN:
      case SummaryElementType.OPEN_PAREN:
      case SummaryElementType.LIST_BULLET:
      case SummaryElementType.LIST_BULLET_ELSE:
      case SummaryElementType.TEXT:
      case SummaryElementType.AND:
      case SummaryElementType.OR:
        value = element.value;
        break;
      case SummaryElementType.LEAF:
        let leafNode = element.value;
        // need to handle this
        value = this.getStringDisplayValueForNode(leafNode, element.expSummaryElementOptions);
        break;
      case SummaryElementType.OPERATOR:
        let operatorNode = element.value;
        if (operatorNode.operatorID != null) {
          let expOperator = this.expressionDomainModel.getExpOperator(operatorNode.operatorID);
          if (expOperator) {
            value = this.getStringDisplayValueForOperatorNode(expOperator);
          }
          value = value || "UNKNOWN";
        }
        break;
      default:
        throw new Error(`Unsupported SummaryElementType: ${element.type}`);
    }
    return value;
  }
  getStringDisplayValueForOperatorNode(expOperator) {
    return expOperator.label;
  }
  getStringDisplayValueForNode(expExpressionNode, expSummaryElementOptions) {
    if (expExpressionNode.listValue != null) {
      return expExpressionNode.listValue.map(lv => this.getStringDisplayValueForReferenceListValue(expExpressionNode, lv)).join(", ");
    } else {
      return this.getFormattedNumberStringValue(expExpressionNode, expSummaryElementOptions, expExpressionNode.displayValue);
    }
  }
  getStringDisplayValueForReferenceListValue(expExpressionNode, listValue, expSummaryElementOptions) {
    return this.getFormattedNumberStringValue(expExpressionNode, expSummaryElementOptions, listValue.value);
  }
  getFormattedNumberStringValue(expExpressionNode, expSummaryElementOptions, value) {
    let stringValue = value;
    if (stringValue && expExpressionNode.categoryID === Expression.Domain.Constants.CATEGORY_LITERAL && expExpressionNode.valueTypeIDs && expExpressionNode.valueTypeIDs?.indexOf(Expression.Domain.Constants.VALUE_TYPE_NUMBER) > -1 && !Number.isNaN(stringValue) && (expSummaryElementOptions?.asPercentage || expSummaryElementOptions?.use1000Separator)) {
      let valueFormatAttributes = {
        valueFormatType: expSummaryElementOptions.asPercentage ? "Percentage" : "Number",
        use1000Separator: !!expSummaryElementOptions.use1000Separator,
        numDecimalPlaces: 0,
        use1000Abbr: false,
        valueFormatOptions: null
      };
      try {
        let numberValue = +stringValue;
        if (expSummaryElementOptions.asPercentage) {
          numberValue = numberValue / 100;
        }
        let formattedString = ValueFormatAttributesUtils.formatNumberAsString(numberValue, valueFormatAttributes);
        stringValue = formattedString;
      } catch (e) {
        console.log(`Unable to format value "${stringValue} for operand ${expExpressionNode.operandName} using: ${JSON.stringify(valueFormatAttributes, null, 2)}`);
      }
    }
    return stringValue ?? "";
  }
  getRichDisplayValueForNode(referenceNode, expSummaryElementOptions) {
    if (referenceNode.listValue != null) {
      let values = [];
      referenceNode.listValue.forEach(lv => {
        if (values.length > 0) {
          values.push(/*#__PURE__*/React.createElement("span", {
            className: "ab-gee-expression-summary-list-value-separator"
          }, ","));
        }
        values.push(this.getRichDisplayValueForListValue(referenceNode, lv, expSummaryElementOptions));
      });
      return values;
    } else {
      return this.getFormattedNumberStringValue(referenceNode, expSummaryElementOptions, referenceNode.displayValue);
    }
  }
  getRichDisplayValueForOperatorNode(expOperator) {
    return expOperator.label;
  }
  getRichDisplayValueForListValue(referenceNode, listValue, expSummaryElementOptions) {
    return this.getFormattedNumberStringValue(referenceNode, expSummaryElementOptions, listValue.value);
  }
}
//# sourceMappingURL=OperandValueValueRenderer.js.map
